module.exports = __webpack_public_path__ + "media/javascripts/apps/shared/assets/images/loading-792777f095784dcad641ae875b13aa7c.gif";